<template>
    <div class="language-wrapper">
        <button class="language button" :class="{ active: activeLanguage === 'nl' }" v-on:click="changeLanguage('nl')">NL</button>
        <button class="language button" :class="{ active: activeLanguage === 'en' }" v-on:click="changeLanguage('en')">EN</button>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.language-wrapper
{
    position: absolute;

    top: 5px;
    right: 20px;
    left: 0px;

    text-align: right;

    z-index: 999;

    .language.button
    {
        font-size: 0.750em;
        font-weight: 200;

        border: 1px none;

        background: transparent;

        margin: 0px;
        padding: 10px;
        border-radius: 10px;

        color: $normal-color;
        outline: none;

        cursor: pointer;

        &.active
        {
            color: $darkest-color;
        }
    }
}
</style>

<script>
import store from '@/store';

export default {
    name: 'language',
    data: () =>
    {
        return {
            activeLanguage: store.getters.activeLanguage,
        };
    },
    methods: {
        changeLanguage: function(language)
        {
            store.dispatch('changeLanguage', language).then(
                () =>
                {
                    this.activeLanguage = store.getters.activeLanguage;
                }
            ).catch(error => `Language could not be loaded: ${error}`);
        },
    },
};
</script>
